<template>
  <div class="full-height"></div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import ServiceRequestController from '../ServiceRequestController'

@Component({
  name: 'ServiceRequestCreate',
  components: {},
  props: {
    client: String,
    type: String,
    origin: String,
    serviceRequestClassification: String,
    serviceObservation: String
  }
})
class ServiceRequestCreate extends Vue {
  controller = ServiceRequestController.getInstance();
  async mounted () {
    await this.controller.create({
      client: this.client,
      type: this.type,
      origin: this.origin,
      serviceRequestClassification: this.serviceRequestClassification,
      serviceObservation: this.serviceObservation
    })
  }
}
export default ServiceRequestCreate
</script>
<style lang="stylus" scoped></style>
